import { transparentize } from 'polished'
import styled from 'styled-components'

import { Link } from '@subaio/components'

import { helpers } from 'styles'

export const DeveloperButton = styled(Link)`
	display: block;
	overflow: hidden;
	position: relative;

	background-color: transparent;

	border-radius: 12px;
	padding: 4px 12px;

	transition: color 0.2s, background-color 0.2s;

	&,
	&:hover,
	&:active,
	&:focus {
		color: inherit;
		text-decoration: none;
	}

	&:is(:hover, :focus-visible) {
		background-color: ${helpers.color.primary.with(transparentize(0.9))};
		color: inherit;
		text-decoration: none;
	}

	&:after {
		content: '';
		display: block;
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		pointer-events: none;
		background-image: radial-gradient(circle, ${helpers.color.primary} 16%, transparent 16.01%);
		background-repeat: no-repeat;
		background-position: 50%;
		transform: scale(10, 10);
		opacity: 0;
		transition: transform 0.7s, opacity 0.9s;
	}

	&:active:after {
		transform: scale(0, 0);
		opacity: 0.3;
		transition: 0s;
	}
`
